import React from 'react';
import { useMessage } from '@tmapy/intl';
import { AppState, useDispatch, useSelector } from '@tmapy/redux';
import { LAYER_IDS } from '@tmapy/beetlejuice-utils';
import { MapSearch } from '@tmapy/map-search';
import { SvgSearch, Panel } from '@tmapy/style-guide';

import './SearchPanel.scss';

import { orderMessages } from './orderMessages';

type PanelProps = {
  onHideBtnClick(): void;
};

type HighlightedFeature = {
  layerId: string;
  featureId: string | number;
};

export const SearchPanel: React.FC<PanelProps> = React.memo((props) => {
  const formatMessage = useMessage();
  const dispatch = useDispatch();

  const { tabs, activeTabId } = useSelector((state) => state.mapSearch);

  const highlightedFeatureIds = useSelector((state: AppState) =>
    state.mapCore.interaction.highlightedFeatures
      .filter(
        (highlightedFeature: HighlightedFeature) =>
          highlightedFeature.layerId === `${LAYER_IDS.SEARCH}-${activeTabId}`,
      )
      .map((highlightedFeature: HighlightedFeature) => highlightedFeature.featureId),
  );

  const highlightedFeaturesCount = useSelector(
    (state) => state.mapCore.interaction.highlightedFeaturesCount,
  );

  return (
    <div className='dmx-searchPanel'>
      <Panel
        title={formatMessage(orderMessages.searchTitle)}
        icon={<SvgSearch />}
        onHideBtnClick={props.onHideBtnClick}
      >
        <MapSearch
          isActive
          tabs={tabs}
          activeTabId={activeTabId}
          dispatch={dispatch}
          highlightedFeatureIds={highlightedFeatureIds}
          highlightedFeaturesCount={highlightedFeaturesCount}
        />
      </Panel>
    </div>
  );
});
